<form
	class="sdp-saml-wizard-form"
	[formGroup]="form"
	novalidate
>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'form.label.email' | translate }}"
					type="text"
					formControlName="email"
				>
				<mat-error *ngIf="form.controls['email'].hasError('required') || form.controls['email'].hasError('invalidEmail')">
					{{ "error.message.email" | translate }}
				</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'form.label.firstname' | translate }}"
					type="text"
					formControlName="firstName"
				>
				<mat-error *ngIf="form.controls['firstName'].hasError('required') || form.controls['lastName'].hasError('invalidString')">
					{{ "error.message.firstname" | translate }}</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'form.label.lastname' | translate }}"
					type="text"
					formControlName="lastName"
				>
				<mat-error *ngIf="form.controls['lastName'].hasError('required') || form.controls['lastName'].hasError('invalidString')">
					{{ "error.message.lastname" | translate }}</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-control">
			<mat-slide-toggle
				[disabled]="isPrimary || isCurrentUser"
				(change)="toggleEnabled($event)"
				formControlName="enabled"
			>
				{{ "sdp.user.wizard.edit.enabled.message" | translate }}
			</mat-slide-toggle>
		</div>
		<div class="sdp-form-control">
			<mat-slide-toggle
				[disabled]="isPrimary || isCurrentUser"
				formControlName="admin"
				(change)="toggleAdmin($event)"
			>
				{{ 'user.wizard.isAdmin' | translate }}
			</mat-slide-toggle>
			<sdp-icon
				[icon]="adminDisabledIcon"
				*ngIf="isAdminEnabled && !isEnabled"
			></sdp-icon>
		</div>
	</div>
</form>